import React from 'react';
import s1 from "../../assets/images/services/pages/erp/1.avif";
import s2 from "../../assets/images/services/pages/erp/2.avif";
import s3 from "../../assets/images/services/pages/erp/3.avif";
import LeftRight from "../../components/ui/LeftRight";
import {erpSoftware} from "../../constants/meta";
import Meta from "../../components/common/Helmet";
import {useTranslation} from "react-i18next";

const ErpSolutions = () => {
  const {t} = useTranslation();
  return (
    <div>
      <Meta
        title={erpSoftware.title}
        description={erpSoftware.description}
        canonical={erpSoftware.canonical}
        keywords={erpSoftware.keywords}
        ogTitle={erpSoftware.title}
        ogDescription={erpSoftware.description}
      />
      <div className="md:w-theme-container w-mobile-container mx-auto">
        <div className="mt-12">
          <LeftRight
            title={t('erpPage.title')}
            isLeft={true}
            textPosition={'justify-center'}
            descriptionPosition={'text-center'}
            descriptionList={[
              t('erpPage.section1.description')
            ]}
            icon={false}
            image={s1}
          />
        </div>
      </div>
      <div className="bg-slate-50 pt-20">
        <div className="md:w-theme-container w-mobile-container mx-auto">
          <div className="mb-24">
            <LeftRight
              title={t('erpPage.section2.title')}
              isLeft={false}
              textPosition={'justify-center'}
              descriptionPosition={'text-center'}
              descriptionList={[
                t('erpPage.section2.description')
              ]}
              icon={false}
              image={s2}
            />
          </div>
        </div>
      </div>
      <div className="md:w-theme-container w-mobile-container mx-auto">
        <div className="mt-12">
          <LeftRight
            title={t('erpPage.section3.title')}
            isLeft={true}
            textPosition={'items-start'}
            descriptionPosition={'text-left'}
            listGroup={[
              t('erpPage.section3.list.0'),
              t('erpPage.section3.list.1'),
              t('erpPage.section3.list.2'),
              t('erpPage.section3.list.3'),
              t('erpPage.section3.list.4'),
              t('erpPage.section3.list.5')
            ]}
            descriptionList={[
              t('erpPage.section3.description')
            ]}
            icon={false}
            image={s3}
          />
        </div>
      </div>
      <div className="bg-black md:py-20 py-5">
        <div className="md:w-theme-container w-mobile-container mx-auto">
          <div className="md:w-[75%] w-full mx-auto rounded-lg bg-[#08141A]">
            <div className="md:p-10 p-8 px-2">
              <h3 className={`md:w-[50%] text-lg text-center md:text-xl text-gray-300 theme-font-bold uppercase mb-10 mx-auto`}>
                {t('erpPage.streamlinedErp')}
              </h3>
              <p className={`text-gray-400 text-base text-center leading-relaxed`}>
                {t('erpPage.streamlinedErpDescription')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErpSolutions;
